Ext.define('SA.view.mapexport.OrientationRadioGroup', {
    alias: 'widget.export-orientation-radiogroup',
    extend: 'SA.view.RadioGroup',

    items: [
        {
            boxLabel: 'Landscape',
            value: 'landscape'
        }, {
            boxLabel: 'Portrait',
            value: 'portrait'
        }
    ],

    initComponent() {
        this.callParent();

        this.mon(this.details, {
            'set:height': this.refresh,
            'set:width': this.refresh,

            scope: this
        });
    },

    afterRender() {
        this.callParent();
        this.refresh();
    },

    refresh() {
        var details = this.details,
            height = details.getHeight(),
            width = details.getWidth();

        if (height > width) {
            this.setValue('portrait');
        }

        if (width > height) {
            this.setValue('landscape');
        }
    }
});